import { useMemo } from 'react';

interface ProfessionalOption {
  id: number;
  name: string;
  isActive?: boolean;
}

interface ServiceProfessionalPickerProps {
  professionals: ProfessionalOption[];
  value: number | null | undefined;
  onChange: (value: number | null) => void;
  allowPending?: boolean;
  pendingLabel?: string;
  disabled?: boolean;
  id?: string;
}

const selectStyle: React.CSSProperties = {
  width: '100%',
  padding: '0.5rem 0.75rem',
  borderRadius: '0.75rem',
  border: '1px solid #d9d9d955',
  fontSize: '0.95rem',
  // background: '#fff',
};

export const ServiceProfessionalPicker: React.FC<ServiceProfessionalPickerProps> = ({
  professionals,
  value,
  onChange,
  allowPending = true,
  pendingLabel = 'Pendiente',
  disabled = false,
  id,
}) => {
  const normalizedOptions = useMemo(() => {
    return professionals
      .map((professional) => ({
        id: professional.id,
        label: professional.name,
        isActive: professional.isActive !== false,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [professionals]);

  return (
    <select
      id={id}
      value={value ?? ''}
      onChange={(event) => {
        const nextValue = event.target.value;
        if (!nextValue) {
          onChange(null);
          return;
        }
        const parsed = Number(nextValue);
        onChange(Number.isFinite(parsed) ? parsed : null);
      }}
      style={selectStyle}
      disabled={disabled}
    >
      {allowPending ? <option value="">{pendingLabel}</option> : null}
      {normalizedOptions.map((option) => (
        <option key={option.id} value={option.id}>
          {option.label}
          {option.isActive ? '' : ' (inactivo)'}
        </option>
      ))}
    </select>
  );
};

export default ServiceProfessionalPicker;
